import axios from '@/api/axios'

const analytics = (id) => {
  return axios({
    method: 'get',
    url: `/excel/analytics/${id}`,
    responseType: 'blob',
  })
}

const calendarPlan = (id) => {
  return axios({
    method: 'get',
    url: `/excel/calendar-plan/${id}`,
    responseType: 'blob',
  })
}

const competitionCalendarPlan = (id) => {
  return axios({
    method: 'get',
    url: `/excel/competition-calendar-plan/${id}`,
    responseType: 'blob',
  })
}

const userReports = (id) => {
  return axios({
    method: 'get',
    url: `/excel/user-reports/${id}`,
    responseType: 'blob',
  })
}
const tariff = (year) => {
  return axios({
    method: 'get',
    url: `/excel/tariff/${year}`,
    responseType: 'blob',
  })
}

const applicationsReporting = (id) => {
  return axios({
    method: 'get',
    url: `/excel/applications-reporting/${id}`,
    responseType: 'blob',
  })
}

export default {
  analytics,
  calendarPlan,
  userReports,
  tariff,
  applicationsReporting,
  competitionCalendarPlan,
}
